import { useField } from 'formik';
import { Box } from 'reflexbox';
import { useTranslation } from 'react-i18next';

import * as graphql from 'generated/graphql';

import Button, { ButtonSize } from '../../../../kakapo-ui-kit/components/editors/Button';
import Select from '../../../../kakapo-ui-kit/components/forms/controls/Select';
import { ParagraphSmall } from '../../../../kakapo-ui-kit/components/common/Paragraph';

import MomentTemplateVariation from './MomentTemplateVariation';

interface IOption {
	label: string;
	value: string;
}

export default function MomentTemplateVariations({
	name,
	defaultTemplateName,
	templates,
	jobTitles,
}: {
	name: string;
	defaultTemplateName: string;
	templates: IOption[];
	jobTitles: IOption[];
}) {
	const { t } = useTranslation();

	const [{ value: variations }, , { setValue: setVariations }] = useField<
		graphql.MomentVariation[] | undefined
	>(name);
	const [{ value: evaluationFormID }, , { setValue: setEvaluationFormID }] = useField<
		string | undefined
	>(defaultTemplateName);

	const selectedEvaluationForm = templates.find((template) => template.value === evaluationFormID);

	return (
		<Box>
			{variations && variations.length > 0 && (
				<Box mb={3}>
					<Box mb={2}>
						<ParagraphSmall color="lightBlueDark">
							{t('common.settings.momentTemplates.variations.title')}
						</ParagraphSmall>
					</Box>

					<Box>
						{(variations ?? []).map((variation, index) => (
							<MomentTemplateVariation
								name={`${name}[${index}]`}
								jobTitles={jobTitles}
								templates={templates}
								onRemove={() => {
									setVariations(variations?.filter((_, i) => i !== index));
								}}
							/>
						))}
					</Box>
				</Box>
			)}

			<Box mb={3}>
				<Box mb={2}>
					<ParagraphSmall color="lightBlueDark">
						{t('common.settings.momentTemplates.variations.default.title')}
					</ParagraphSmall>
				</Box>

				<Select
					unspaced
					small
					value={selectedEvaluationForm}
					options={templates}
					onChange={(value) => {
						if (!value) {
							return;
						}

						setEvaluationFormID(value.value);
					}}
				/>
			</Box>

			{/* Only allow adding exceptions when there are job titles and templates */}
			{templates.length > 0 && jobTitles.length > 0 && (
				<Button
					size={ButtonSize.Small}
					onClick={() => {
						setVariations(
							(variations ?? []).concat([
								{
									evaluation: {
										evaluationForm: ({
											id: templates[0].value,
										} as unknown) as graphql.EvaluationForm,
									},
									jobTitle: ({
										id: jobTitles[0].value,
									} as unknown) as graphql.JobTitle,
								},
							]),
						);
					}}
				>
					{t('common.settings.momentTemplates.variations.add.buttonTitle')}
				</Button>
			)}
		</Box>
	);
}
